export const servicesData = [
  {
    index: 0,
    name: "Entrega de pulsera y vaso",
    coords: [
      [25.680556, -100.277844],
      [25.678565, -100.283142],
      [25.679045, -100.286204],
      [25.681910, -100.286022],
      [25.680871, -100.282031],
    ],
    color: '#CA846B',
    type: 'Servicios',
  },
  {
    index: 1,
    name: "Restaurantes",
    coords: [
      [25.681637, -100.282433]
    ],
    color: '#F5C44E',
    type: 'Servicios',
  },
  {
    index: 2,
    name: "Food trucks",
    coords: [
      [25.678595, -100.282185]
    ],
    color: '#FD6C0F',
    type: 'Servicios',
  },
  {
    index: 3,
    name: "Callejón del postre",
    coords: [
      [25.678703, -100.283480]
    ],
    color: '#EC3391',
    type: 'Servicios',
  },
  {
    index: 4,
    name: "Mercado",
    coords: [
      [25.679114, -100.284194]
    ],
    color: '#EA3A95',
    type: 'Servicios',
  },
  {
    index: 5,
    name: "Free water (agua gratis)",
    coords: [
      [25.681370, -100.282858],
      [25.679873, -100.284542],
      [25.680755, -100.279695],
      [25.680303, -100.277798]
    ],
    color: '#1d77d3',
    type: 'Servicios',
  },
  {
    index: 6,
    name: "Baños",
    coords: [
      [25.678840, -100.283617],
      [25.680208, -100.285218],
      [25.681910, -100.282911],
      [25.679127, -100.279793],
      [25.682252, -100.281705],
      [25.681144, -100.278056],
      [25.677842, -100.279793],
      [25.677692, -100.281773],
    ],
    color: '#12A8DF',
    type: 'Servicios',
  },
  {
    index: 7,
    name: "Cajeros",
    coords: [
      [25.681760, -100.282707],
      [25.680741, -100.279460],
    ],
    color: '#B319F5',
    type: 'Servicios',
  },
  {
    index: 8,
    name: "Check in vaso Tecate",
    coords: [
      [25.679045, -100.285923],
      [25.680871, -100.282024],
    ],
    color: '#720000',
    type: 'Servicios',
  },
  {
    index: 9,
    name: "Tienda oficial",
    coords: [
      [25.679264, -100.284641],
      [25.680625, -100.282904],
    ],
    color: '#672F8A',
    type: 'Servicios',
  },
  {
    index: 10,
    name: "Lockers",
    coords: [
      [25.681308, -100.282267]
    ],
    color: '#52B649',
    type: 'Servicios',
  },
  {
    index: 11,
    name: "Pista de hielo",
    coords: [
      [25.678519, -100.282320]
    ],
    color: '#0001FC',
    type: 'Servicios',
  },
  {
    index: 13,
    name: "Puente Maravilla",
    coords: [
      [25.680242, -100.279763]
    ],
    color: '#FF7F00',
    type: 'Servicios',
  },
  {
    index: 14,
    name: "Área de descanso",
    coords: [
      [25.678792, -100.282927]
    ],
    color: '#481801',
    type: 'Servicios',
  },
  {
    index: 15,
    name: "Servicios médicos",
    coords: [
      [25.681035, -100.285271],
      [25.680228, -100.284641],
      [25.679784, -100.282540],
      [25.678225, -100.280150],
      [25.681343, -100.279573],
      [25.679011, -100.278223],
      [25.678922, -100.283951],
      [25.682060, -100.283480],
    ],
    color: '#EB1C24',
    type: 'Servicios',
  },
  {
    index: 16,
    name: "Zona NFTs",
    coords: [
      [25.679175, -100.278906]
    ],
    color: '#0171B2',
    type: 'Servicios',
  }
]
